import { o_util } from "../common/namespaces";
import type { GlobalUtils } from "../exports";

/**
 *
 *
 */
export type ToggleSync = GlobalUtils["toggle"];

/**
 *
 *
 */
export const toggleSync: ToggleSync = o_util.toggle;
